import { createSelector } from "reselect";

const getLinksMagicLink = state => state.get("linksMagicLinkReducer");

export const selectMagicLink = createSelector(
  [getLinksMagicLink],
  linksMagicLink => {
    return linksMagicLink.get("myLinks").toArray();
  }
);
